/*******************************
 *  --scrollbar-width and --window-height CSS variables
 ******************************/

function calculateScrollbarWidth() {
  var scrollbarWidth = window.innerWidth - document.body.clientWidth
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px')
}
calculateScrollbarWidth()

function calculateWindowHeight() {
  document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px')
}
calculateWindowHeight()

window.addEventListener('resize', () => {
  requestAnimationFrame(() => {
    calculateScrollbarWidth()
    calculateWindowHeight()
  })
})
